module.exports = __webpack_public_path__ + "static/media/think-about-it.3705b5c7.png";